import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { LoadingButton } from '@mui/lab';
import { Button, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { ID_LOADING_BUTTON, SLICE_NAME, TYPE_UPDATE_LOADING_BUTTON } from 'constants/common';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { updateLoadingButton } from 'store/commonSlice';
import { setCloseDialogCC, toLowerCaseNonAccentVietnamese } from 'utils/helpers';
import DialogBaseCC from './DialogBaseCC';
import { DIALOG_ID } from './constant';

const DialogConfirm = () => {
    const propsDialog = useLegacyDialogProps();
    const { t } = useTranslation()
    const { title, contentText, onClick, titleActions, onCancel, isDisableLoadingButton, is_active, cancel = t('dialog.cancel'), action = t('dialog.delete') } = propsDialog
    const { isLoading } = useSelector(state => state[SLICE_NAME.COMMON])
    const dispatch = useDispatch()

    let _cancel = cancel;
    let _action = action;

    if (toLowerCaseNonAccentVietnamese(title).includes('ketthuc')) {
        _cancel = t('dialog.back')
        _action = t('dialog.end')
    }

    if (toLowerCaseNonAccentVietnamese(title).includes('huy')) {
        _cancel = t('dialog.back')
        _action = t('dialog.cancel')
    }

    if (toLowerCaseNonAccentVietnamese(title).includes('huy')) {
        _cancel = t('dialog.back')
        _action = t('dialog.cancel')
    }

    if (toLowerCaseNonAccentVietnamese(title).includes('tontai')) {
        _cancel = t('dialog.back')
        _action = t('dialog.confirm')
    }

    if (toLowerCaseNonAccentVietnamese(title).includes(toLowerCaseNonAccentVietnamese(t('room.pop-up.password.title')))) {
        _cancel = t('actions.noReset')
        _action = t('actions.addPwd')
    }

    if (toLowerCaseNonAccentVietnamese(title).includes(toLowerCaseNonAccentVietnamese(t('breadcrumb.title-restore-popup')))) {
        _cancel = t('actions.cancel')
        _action = t('actions.restore')
    }

    if (toLowerCaseNonAccentVietnamese(title).includes(toLowerCaseNonAccentVietnamese(t('room.pop-up.confirm.title')))) {
        _action = t('room.pop-up.confirm.actionText')
    }

    if (toLowerCaseNonAccentVietnamese(title).includes(toLowerCaseNonAccentVietnamese(t('room.pop-up.cancel.title')))) {
        _action = t('room.pop-up.cancel.save')
    }

    if (toLowerCaseNonAccentVietnamese(title).includes(toLowerCaseNonAccentVietnamese(t('room.pop-up.end.title')))) {
        _action = t('dialog.end')
    }

    if (toLowerCaseNonAccentVietnamese(title).includes(toLowerCaseNonAccentVietnamese(t('dialog.role.title-delete'))) && !is_active) {
        _action = t('dialog.role.action')
    } else if(toLowerCaseNonAccentVietnamese(title).includes(toLowerCaseNonAccentVietnamese(t('dialog.role.title-delete')))){
        _action = t('dialog.role.action-ok')
    }

    if (toLowerCaseNonAccentVietnamese(title).includes(toLowerCaseNonAccentVietnamese(t('dialog.func.title-delete'))) && !is_active) {
        _action = t('dialog.func.action')
    } else if(toLowerCaseNonAccentVietnamese(title).includes(toLowerCaseNonAccentVietnamese(t('dialog.func.title-delete')))){
        _action = t('dialog.func.action-ok')
    }
    if (toLowerCaseNonAccentVietnamese(title).includes(toLowerCaseNonAccentVietnamese(t('title.confirmDeleteEvent'))) && is_active === 0) {
        _action = t('dialog.event.action')
    } else if(toLowerCaseNonAccentVietnamese(title).includes(toLowerCaseNonAccentVietnamese(t('title.confirmDeleteEvent')))){
        _action = t('dialog.event.action-ok')
    }

    const handleOnClick = _ => {
        dispatch(updateLoadingButton({type: TYPE_UPDATE_LOADING_BUTTON.ADD, id: ID_LOADING_BUTTON.CONFIRM_DIALOG}))
        onClick()
    }

    const handleCancel = () => {
        setCloseDialogCC()
        if (onCancel) onCancel()
    }

    return (
        <DialogBaseCC id={DIALOG_ID.CONFIRM} title={title}>
            <DialogContent>
                <DialogContentText>
                    {contentText}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={handleCancel}>{_cancel}</Button>
                <LoadingButton variant='contained' loading={!isDisableLoadingButton && isLoading} onClick={handleOnClick}>{titleActions || _action}</LoadingButton>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialogConfirm